import { combineReducers } from 'redux';
import variaveis from './slices/variaveis.slice';
import tabelas from './slices/tabelas.slice';
import configVariaveis from './slices/configVariaveis.slice';

const reducer = combineReducers({
  variaveis,
  tabelas,
  configVariaveis
})

export default reducer;
